/** @flow */
export default {
  en: {
    HELP: "Help",
    HELP_CENTRE: "Help Centre",
    PREFER_A_VISUAL: "Prefer a visual?",
    RTW_INTERVIEWS: "RTW Interviews",
    USER_ACCOUNTS: "User Accounts",
    NOTIFICATIONS: "Notifications",
    ABSENCES: "Absences",
    REPORTS: "Reports",
    REACH_US_BY_EMAIL: "You can contact us at:",
    OUR_CUSTOMER_SUPPORT_LINE_AVAILABLE:
      "Our Customer Support Line is available Monday to Friday 9:00am to 5:00pm.",
    HELP_EMPTY_TEXT_1:
      "The Help Centre is designed to support you in your use of Insight. Feeling unsure of what to do or where to go? We have the answers. The menu on the left allows you to search for a specific issue, view a variety of topics or simply browse the full list of options available.",
    HELP_EMPTY_TEXT_2:
      "If you still can’t find the answer you’re looking for, please reach out to a Client Admin user within your organisation.",
    THE_VIDEO_BELOW_WILL_GUIDE_YOU_THROUGH_THE_PROCESS_AS_WELL:
      "The video below will guide you through the process as well:",
    HELP_1: "How do I cancel an absence?",
    HELP_1_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_1_2: "2. Select <strong>Administration</strong> from the drop-down list.",
    HELP_1_3: "3. Select the <strong>Employees page</strong>.",
    HELP_1_4: "4. Search for the employee whose absence you wish to cancel.",
    HELP_1_5: "5. Select the required employee from the search results list.",
    HELP_1_6: "6. Click on the <strong>Absence Details</strong> tab of the employee's record.",
    HELP_1_7: "7. Locate the absence you wish to cancel and click the Edit button (Pencil icon).",
    HELP_1_8: "8. Change the Status field to be <strong>Cancelled</strong>.",
    HELP_1_9: "9. Click <strong>Save</strong>.",
    HELP_2: "How do I disable a user's account?",
    HELP_2_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_2_2: "2. Select Administration from the drop-down list.",
    HELP_2_3: "3. Select the <strong>Employees</strong> page.",
    HELP_2_4: "4. Search for the employee whose account you wish to disable.",
    HELP_2_5: "5. Select the required employee from the search results list.",
    HELP_2_6:
      "6. Click on the <strong>User Account Details</strong> tab of the employee&apos;s record.",
    HELP_2_7: "7. Click the <strong>Edit</strong> button in the Access Level section.",
    HELP_2_8: "8. Select the user type <strong>No access</strong>.",
    HELP_2_9: "9. Click <strong>Save</strong>.",
    HELP_3: "How do I change an employee's notification contacts?",
    HELP_3_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_3_2: "2. Select Administration from the drop-down list.",
    HELP_3_3: "3. Select the <strong>Employees</strong> page.",
    HELP_3_4: "4. Search for the employee whose notification contacts you wish to update.",
    HELP_3_5: "5. Select the required employee from the search results list.",
    HELP_3_6: "6. Click on the <strong>Notifications To</strong> tab of the employee's record.",
    HELP_3_7a:
      "7A. Click the <strong>Add Recipient</strong> button to add a new notification contact.",
    HELP_3_7b: "7B. Click <strong>Delete</strong> (Red Bin Icon) to delete a selection contact.",
    HELP_3_7c:
      "7C. Click <strong>Edit</strong> (Pencil Icon) to edit a notification contact and change its type.",
    HELP_4: "How do I change a user's access level?",
    HELP_4_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_4_2: "2. Select Administration from the drop-down list.",
    HELP_4_3: "3. Select the <strong>Employees</strong> page.",
    HELP_4_4: "4. Search for the employee whose access level you wish to change.",
    HELP_4_5: "5. Select the required employee from the search results list.",
    HELP_4_6:
      "6. Click on the <strong>User Account Details</strong> tab of the employee&apos;s record.",
    HELP_4_7: "7. Click the <strong>Edit</strong> button in the Access Level section.",
    HELP_4_8: "8. Select the new access level.",
    HELP_4_9: "9. Click <strong>Save</strong>.",
    HELP_5: "How do I export a list of active users?",
    HELP_5_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_5_2: "2. Select Administration from the drop-down list.",
    HELP_5_3: "3. Select the <strong>Service</strong> page.",
    HELP_5_4: "4. Select <strong>Security</strong> in the side menu.",
    HELP_5_5: "5. Select the <strong>User Accounts</strong> page.",
    HELP_5_6: "6. Apply your required filters and click <strong>Apply</strong>.",
    HELP_5_7: "7. Click <strong>Export</strong>.",
    HELP_6: "How do I add an absence to an employee record?",
    HELP_6_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_6_2: "2. Select Administration from the drop-down list.",
    HELP_6_3: "3. Select the <strong>Employees</strong> page.",
    HELP_6_4: "4. Search for the employee you wish to add an absence to.",
    HELP_6_5: "5. Select the required employee from the search results list.",
    HELP_6_6: "6. Click on the <strong>Absence Details</strong> tab of the employee's record.",
    HELP_6_7: "7. Click <strong>Add Absence</strong>.",
    HELP_6_8: "8. Complete the Absence Details form that appears.",
    HELP_6_9: "9. Click <strong>Add Absence</strong>.",
    HELP_6_10: "10. Select the newly added absence from the Absence History list.",
    HELP_6_11: "11. Scroll to <strong>Set Shift Pattern</strong>.",
    HELP_6_12: "12. Click <strong>Edit</strong>.",
    HELP_6_13: "13. Populate the time lost for each day of the absence.",
    HELP_6_14: "14. Click <strong>Save</strong>.",
    HELP_7: "How do I reset a user's password?",
    HELP_7_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_7_2: "2. Select Administration from the drop-down list.",
    HELP_7_3: "3. Select the <strong>Employees</strong> page.",
    HELP_7_4: "4. Search for the employee whose password you wish to reset.",
    HELP_7_5: "5. Select the required employee from the search results list.",
    HELP_7_6: "6. Click on the <strong>User Account Details</strong> tab of the employee's record.",
    HELP_7_7: "7. Click <strong>Reset Password</strong>.",
    HELP_8: "How do I make an employee a leaver?",
    HELP_8_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_8_2: "2. Select Administration from the drop-down list.",
    HELP_8_3: "3. Select the <strong>Employees</strong> page.",
    HELP_8_4: "4. Search for the employee who has left your organisation.",
    HELP_8_5: "5. Select the required employee from the search results list.",
    HELP_8_6: "6. Click on the <strong>Personal Details</strong> tab.",
    HELP_8_7: "7. Click <strong>Edit</strong> on the Employment Info section.",
    HELP_8_8: "8. Enter the employee's leaving date in the Employment End Date field.",
    HELP_8_9: "9. Click <strong>Save</strong>.",
    HELP_8_10:
      "<strong>Note 1:</strong> The same end date will automatically apply to any active positions held by the employee.",
    HELP_9: "How do I move an employee to a new department?",
    HELP_9_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_9_2: "2. Select Administration from the drop-down list.",
    HELP_9_3: "3. Select the <strong>Employees</strong> page.",
    HELP_9_4: "4. Search for the employee whose department you wish to change.",
    HELP_9_5: "5. Select the required employee from the search results list.",
    HELP_9_6: "6. Select the <strong>Employment Details</strong> tab.",
    HELP_9_7:
      "7. Click <strong>Edit</strong> (Pencil Icon) to the left of the job role that needs to move department.",
    HELP_9_8: "8. Click in the <strong>Department</strong> Field.",
    HELP_9_9: "9. Select the new Department.",
    HELP_9_10: "10. Click <strong>Done</strong>.",
    HELP_9_11: "11. Click <strong>Save</strong>.",
    HELP_10: "How do I export our current Staff In Post (SIP) data?",
    HELP_10_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_10_2: "2. Select Administration from the drop-down list.",
    HELP_10_3: "3. Select the <strong>Data</strong> page.",
    HELP_10_4: "4. Select <strong>Export Data</strong>.",
    HELP_10_5:
      "5. Select the hierarchy area the export must cover (defaults to whole organisation).",
    HELP_10_6: "6. Click <strong>Export Current Data</strong>.",
    HELP_10_7:
      "<strong>Note 1</strong>: A log of your transfer will be kept by the system and will show in the Transfer File History.",
    HELP_11: "How do I transfer a sensitive data file to GoodShape?",
    HELP_11_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_11_2: "2. Select Administration from the drop-down list.",
    HELP_11_3: "3. Select the <strong>Data</strong> page.",
    HELP_11_4: "4. Select <strong>Data Transfer</strong>.",
    HELP_11_5: "5. Click <strong>Choose File</strong>.",
    HELP_11_6: "6. Search for and select your required file.",
    HELP_11_7: "7. Click <strong>Transfer File</strong>.",
    HELP_11_8:
      "<strong>Note 1</strong>: Files must be XLS, XLSX or CSV. A log of your export will be kept by the system and will show in the Export History.",
    HELP_12: "How do I create a new employee record?",
    HELP_12_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_12_2: "2. Select Administration from the drop-down list.",
    HELP_12_3: "3. Select the <strong>Employees</strong> page.",
    HELP_12_4: "4. Click <strong>Add New Employee</strong>.",
    HELP_12_5: "5. Populate the Add New Employee form.",
    HELP_12_6: "6. Click <strong>Add Employee</strong>.",
    HELP_12_7:
      "<strong>Note 1:</strong> The employee will default to being in the Unassigned department.",
    HELP_12_8:
      "<strong>Note 2:</strong> View the Employment Details tab of their record to assign them to the required department.",
    HELP_13: "How do I find my outstanding Return to Work Interviews?",
    HELP_13_1: "1. Click <strong>Go Task Queue</strong> in the header bar at the top of the page.",
    HELP_13_2:
      "2. Click <strong>RTW</strong> to filter the task queue to Return to Work Interviews.",
    HELP_14: "How do I find a list of currently absent staff?",
    HELP_14_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_14_2: "2. Select Reporting from the drop-down list.",
    HELP_14_3: "3. Select <strong>Absences</strong> in the navigation menu.",
    HELP_14_4: "4. Click <strong>Run</strong> for the Current Open Absences report.",
    HELP_15: "How can I find a specific employee record?",
    HELP_15_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_15_2: "2. Select <strong>Reporting</strong> from the drop-down list.",
    HELP_15_3:
      "3. Click in the <strong>Search employee surname</strong> field in the header bar <strong>or select the Employees</strong> page.",
    HELP_15_4: "4. Type the surname of the employee you wish to find.",
    HELP_15_5: "5. Click <strong>Apply</strong>.",
    HELP_15_6: "6. Review the list of results.",
    HELP_15_7: "7. Select the employee's record.",
    HELP_16: "How do I upload a document to an employee record?",
    HELP_16_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_16_2: "2. Select Reporting from the drop-down list.",
    HELP_16_3: "3. Select the <strong>Employees</strong> page.",
    HELP_16_4: "4. Type the surname of the employee you wish to find.",
    HELP_16_5: "5. Click <strong>Apply</strong>.",
    HELP_16_6: "6. Review the list of results.",
    HELP_16_7: "7. Click <strong>Select</strong> to access the required employee record.",
    HELP_16_8: "8. Click <strong>Documents</strong> in the side menu.",
    HELP_16_9: "9. Click <strong>Add Document</strong>.",
    HELP_16_10: "10. Select the Document Type from the drop-down list.",
    HELP_16_11: "11. Click <strong>Choose File</strong> and select the File you wish to upload.",
    HELP_16_12: "12. Click <strong>Add</strong>.",
    HELP_17: "How do I add a note to an absence record?",
    HELP_17_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_17_2: "2. Select Reporting from the drop-down list.",
    HELP_17_3: "3. Select the <strong>Employees</strong> page.",
    HELP_17_4: "4. Type the surname of the employee you wish to find.",
    HELP_17_5: "5. Click <strong>Apply</strong>.",
    HELP_17_6: "6. Review the list of results.",
    HELP_17_7: "7. Click <strong>Select</strong> to access the required employee record.",
    HELP_17_8: "8. Click <strong>Absence History</strong> in the side menu.",
    HELP_17_9: "9. Select the required absence (Magnifying Glass Icon).",
    HELP_17_10: "10. Scroll to the <strong>Notes</strong> section of the page.",
    HELP_17_11: "11. Click <strong>Add Note</strong>.",
    HELP_17_12: "12. Select the type of <strong>Absence Note</strong> you are adding.",
    HELP_17_13: "13. Enter your notes in the <strong>Notes</strong> field.",
    HELP_17_14: "14. Click <strong>Add Note</strong>.",
    HELP_18: "How do I view an employee's absence history?",
    HELP_18_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_18_2: "2. Select Reporting from the drop-down list.",
    HELP_18_3: "3. Select the <strong>Employees</strong> page.",
    HELP_18_4: "4. Type the surname of the employee you wish to find.",
    HELP_18_5: "5. Click <strong>Apply</strong>.",
    HELP_18_6: "6. Review the list of results.",
    HELP_18_7: "7. Select the employee's record.",
    HELP_18_8: "8. Select the <strong>Absence History</strong> tab.",
    HELP_19: "How do I view an employee's absence statistics?",
    HELP_19_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_19_2: "2. Select Reporting from the drop-down list.",
    HELP_19_3: "3. Select the <strong>Employees</strong> page.",
    HELP_19_4: "4. Type the surname of the employee you wish to find.",
    HELP_19_5: "5. Click <strong>Apply</strong>.",
    HELP_19_6: "6. Review the list of results.",
    HELP_19_7: "7. Select the employee's record.",
    HELP_19_8: "8. Select the <strong>Absence Statistics</strong> tab.",
    HELP_20: "How do I submit a Return to Work Interview?",
    HELP_20_1: "1. Click <strong>Go Task Queue</strong> in the header bar at the top of the page.",
    HELP_20_2:
      "2. Click <strong>RTW</strong> to filter the task queue to Return to Work Interviews.",
    HELP_20_3: "3. Select the required task list from the list on the left of the screen.",
    HELP_20_4: "4. The Return to Work Interview form will open on the right of the screen.",
    HELP_20_5: "5. Scroll to <strong>RTW Interview</strong>.",
    HELP_20_6: "6. Enter the answers to each of the questions shown.",
    HELP_20_7:
      "7. Ensure that all <strong>mandatory</strong> responses are provided (Orange Asterisk).",
    HELP_20_8: "8. Enter the <strong>Date & Time Interview Completed</strong>.",
    HELP_20_9: "9. Click <strong>Submit</strong>.",
    HELP_20_10:
      "<strong>Note 1:</strong> If you get interrupted you can keep your progress by pressing <strong>Save Draft</strong>.",
    HELP_20_11:
      "<strong>Note 2:</strong> You can print a copy of your completed form by pressing <strong>Print Form</strong>.",
    HELP_21: "How do I see a summary of today's absence activity?",
    HELP_21_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_21_2: "2. Select Reporting from the drop-down list.",
    HELP_21_3: "3. Select <strong>Dashboard</strong>.",
    HELP_21_4: "4. Select <strong>Latest Activities</strong>.",
    HELP_22: "How do I create an absence report?",
    HELP_22_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_22_2: "2. Select Reporting from the drop-down list.",
    HELP_22_3: "3. Select <strong>Absences</strong>.",
    HELP_22_4: "4. Click <strong>Create New Report</strong>.",
    HELP_22_5:
      "5. Select the <strong>Hierarchy Areas</strong> you want to be in scope of the report.",
    HELP_22_6: "6. Click <strong>Next: Choose Filters</strong>.",
    HELP_22_7: "7. Chosen your required <strong>Date Range</strong>.",
    HELP_22_8: "8. Populate the remaining filters as required.",
    HELP_22_9: "9. Ensure all mandatory filters are populated.",
    HELP_22_10: "9. Click <strong>Generate Report</strong>.",
    HELP_22_11:
      "<strong>Note 1:</strong> Once you create a report you can click <strong>Save</strong> to retain it for future use.",
    HELP_23: "How do I view absence rate trends?",
    HELP_23_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_23_2: "2. Select Reporting from the drop-down list.",
    HELP_23_3: "3. Select <strong>Trend Reports</strong>.",
    HELP_23_4: "4. Select <strong>Absence Rate Trends</strong>.",
    HELP_23_5:
      "5. Review the list of available Trends in the <strong>Standard Reports</strong> list.",
    HELP_23_6: "6. Click <strong>Run</strong> for your required absence rate trend.",
    HELP_24: "How do I upload a document to an absence record?",
    HELP_24_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_24_2: "2. Select Reporting from the drop-down list.",
    HELP_24_3: "3. Select the <strong>Employees</strong> page.",
    HELP_24_4: "4. Type the surname of the employee you wish to find.",
    HELP_24_5: "5. Click <strong>Apply</strong>.",
    HELP_24_6: "6. Review the list of results.",
    HELP_24_7: "7. Click <strong>Select</strong> to access the required employee record.",
    HELP_24_8: "8. Click <strong>Absence History</strong> in the side menu.",
    HELP_24_9: "9. Select the required absence (Magnifying Glass Icon).",
    HELP_24_10: "10. Scroll to the <strong>Documents</strong> section of the page.",
    HELP_24_11: "11. Click <strong>Add Document</strong>.",
    HELP_24_12: "12. Select the Document Type from the drop-down list.",
    HELP_24_13: "13. Click <strong>Choose File</strong> and select the File you wish to upload.",
    HELP_24_14: "14. Click <strong>Add Document</strong>.",
    HELP_25: "How do I add a Department Notification contact?",
    HELP_25_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_25_2: "2. Select Administration from the drop-down list.",
    HELP_25_3: "3. Select the <strong>Hierarchy</strong> page.",
    HELP_25_4: "4. Click <strong>Department Contacts</strong>.",
    HELP_25_5: "5. Select the department you need to add the contact to in the hierarchy.",
    HELP_25_6: "6. Click <strong>Add Contact</strong>.",
    HELP_25_7:
      "7. Enter the surname of the contact you wish to add and click the Magnifying glass.",
    HELP_25_8: "8. Select the required contact.",
    HELP_25_9: "9. Select the required <strong>Notification Type</strong>.",
    HELP_25_10: "10. Select the required <strong>Department Scope</strong>.",
    HELP_25_11: "11. Click <strong>Add Contact</strong>.",
    HELP_25_12:
      "<strong>Note 1</strong>: You can use the Find Department search bar to locate a department.",
    HELP_26: "How do I remove a Department Notification contact?",
    HELP_26_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_26_2: "2. Select Administration from the drop-down list.",
    HELP_26_3: "3. Select the <strong>Hierarchy</strong> page.",
    HELP_26_4: "4. Click <strong>Department Contacts</strong>.",
    HELP_26_5: "5. Select the required department.",
    HELP_26_6: "6. Locate the notification contact you wish to delete.",
    HELP_26_7: "7. Click Delete (Red Trash Can) next to the Notification Contact.",
    HELP_26_8:
      "<strong>Note 1</strong>: You can use the Find Department search bar to locate a department.",
    HELP_26_9:
      "<strong>Note 2</strong>: You can select multiple contacts clicking the tick-boxes to the left of the employee references.",
    HELP_27: "How do I see which employees have the most absence?",
    HELP_27_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_27_2: "2. Select Reporting from the drop-down list.",
    HELP_27_3: "3. Select <strong>Focus Lists</strong>.",
    HELP_27_4: "4. Select <strong>Focus Lists</strong> from the top menu.",
    HELP_27_5: "5. Select <strong>Employee Focus List</strong>.",
    HELP_27_6: "6. Click <strong>Run</strong> for the Focus List of your choice.",
    HELP_27_7:
      "<strong>Note 1</strong>: You can edit and create your own reports as well as running the Standard Reports.",
    HELP_28: "How do I see who has recently triggered a policy alert?",
    HELP_28_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_28_2: "2. Select Reporting from the drop-down list.",
    HELP_28_3: "3. Select <strong>Alerts</strong>.",
    HELP_28_4: "4. Click <strong>Run</strong> for the Alerts in the Last 7 Days report.",
    HELP_28_5: "5. Click <strong>Run</strong> for the Focus List of your choice.",
    HELP_28_6:
      "<strong>Note 1</strong>: You can edit and create your own reports as well as running the Standard Reports.",
    HELP_28_7:
      "<strong>Note 2</strong>: You can run reports for longer periods of time or create and edit your own reports too.",
    HELP_29: "How do I change my password?",
    HELP_29_1: "1. Select <strong>Account & Options</strong> in the top right corner.",
    HELP_29_2: "2. Select My Details from the drop-down list.",
    HELP_29_3: "3. Click <strong>Change Password</strong>.",
    HELP_29_4: "4. Enter your current password, ensuring it meets the complexity criteria.",
    HELP_29_5: "5. Confirm your new password.",
    HELP_29_6: "6. Click <strong>Change Password</strong>.",
    HELP_30: "How do I access recent absence notifications?",
    HELP_30_1: "1. Click <strong>Go Task Queue</strong> in the system header.",
    HELP_30_2: "2. Click <strong>Notification Inbox</strong>.",
  },
};
